import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FileService } from '../../services/file.service';
import { StateService } from '../../../../shared/service/state.service';
import { first } from 'rxjs';

@Component({
  selector: 'refactor-pages-generate-code',
  standalone: false,
  templateUrl: './generate-code.component.html',
  styleUrl: './generate-code.component.scss'
})
export class GenerateCodeComponent {

  refactorResponse: any = null;

  constructor(
    private router: Router,
    private fileService: FileService,
    private stateService: StateService,
  ) { }

  onDownload(): void {
    this.stateService.refactorResponse$.pipe(first()).subscribe(response => {
      if (response?.file?.data) {
        this.refactorResponse = response;
        this.downloadFile();
      }
    });
  }

  private downloadFile(): void {
    if (!this.refactorResponse?.file?.data) return;
    const { data, name, mime } = this.refactorResponse.file;
    // this.fileService.downloadFile(data, name, mime);
  }

  showCode() {
    this.router.navigate(['/coding/refactor/show-code']);
  }

  returnfileUpload() {
    this.router.navigate(['/coding/refactor/upload-files']);
  }
}
